import {Injectable, NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { EditFundComponent } from 'src/app/modules/product/components/edit-fund/edit-fund.component';
import { FeeTransferComponent } from 'src/app/modules/product/components/fee-transfer/fee-transfer.component';
import { EditDividendComponent } from 'src/app/modules/product/components/edit-dividend/edit-dividend.component';
import { EditSipComponent } from './components/edit-sip/edit-sip.component';
import { EditGoldComponent } from './components/edit-gold/edit-gold.component';
import { GoldListComponent } from './components/gold-list/gold-list.component';
import { NAVListComponent } from './components/nav-list/nav-list.component';
import { FundListComponent } from './components/fund-list/fund-list.component';
import { TabsEditFundComponent } from './components/tabs-edit-fund/tabs-edit-fund.component';
import { DividendListComponent } from './components/dividend-list/dividend-list.component';
import { SipListComponent } from './components/sip-list/sip-list.component';
import { SetUpNewFeeFundComponent } from './components/set-up-new-fee-fund/set-up-new-fee-fund.component';

export const productRoute: Routes = [
  {
    path: '',
    redirectTo: '/products/fund/list',
    pathMatch: 'full',
  },
  {
    path: 'fund',
    data: {
      authorities: [],
      title: 'Chứng chỉ quỹ',
      header: 'Chứng chỉ quỹ'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'prefix'
      },
      {
        path: 'list',
        component: FundListComponent,
        data: {
          authorities: [],
          title: 'Danh sách',
        },
      },
      {
        path: 'create',
        component: EditFundComponent,
        data: {
          authorities: [],
          title: 'Tạo mới',
        },
      },
      
      {
        path: 'edit/:id',
        component: TabsEditFundComponent,
        data: {
          authorities: [],
          title: 'Chỉnh sửa',
        },
      },
      {
        path: 'approve/:id',
        component: EditFundComponent,
        data: {
          authorities: [],
          title: 'Duyệt quỹ',
        },
      },
      {
        path: 'fee-transfer/:id/:name',
        component: FeeTransferComponent,
        data: {
          authorities: [],
          title: 'Phí chuyển đổi',
        },
      },
      {
        path: 'new-fee/:id',
        component: SetUpNewFeeFundComponent,
        data: {
          authorities: [],
          title: 'Nhập phí tương lai',
        },
      },
    ]
  },
  {
    path: 'sip',
    data: {
      authorities: [],
      title: 'SIP',
      header: 'SIP'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'prefix'
      },
      {
        path: 'list',
        component: SipListComponent,
        data: {
          authorities: [],
          title: 'Danh sách',
        },
      },
      {
        path: 'edit/:id',
        component: EditSipComponent,
        data: {
          authorities: [],
          title: 'Chỉnh sửa',
        },
      },
      {
        path: 'create',
        component: EditSipComponent,
        data: {
          authorities: [],
          title: 'Tạo mới',
        },
      },
      
      {
        path: 'fee-transfer/:id/:sipId/:sipName',
        component: FeeTransferComponent,
        data: {
          authorities: [],
          title: 'Phí chuyển đổi',
        },
      },
      {
        path: 'new-fee/:id',
        component: SetUpNewFeeFundComponent,
        data: {
          authorities: [],
          isSip: false,
          title: 'Nhập phí tương lai',
        },
      },
      {
        path: 'new-fee/:id/:sipId',
        component: SetUpNewFeeFundComponent,
        data: {
          authorities: [],
          isSip: true,
          title: 'Nhập phí tương lai',
        },
      },
    ]
  },
  
  {
    path: 'gold',
    data: {
      authorities: [],
      title: 'Vàng & Bạc',
      header: 'Vàng & Bạc'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'prefix'
      },
      {
        path: 'edit/:id',
        component: EditGoldComponent,
        data: {
          authorities: [],
          title: 'Chỉnh sửa',
        },
      },
      {
        path: 'list',
        component: GoldListComponent,
        data: {
          authorities: [],
          title: 'Danh sách',
        },
      },
      {
        path: 'create',
        component: EditGoldComponent,
        data: {
          authorities: [],
          title: 'Tạo mới',
        },
      },
      {
        path: 'approve/:id',
        component: EditGoldComponent,
        data: {
          authorities: [],
          title: 'Duyệt',
        },
      },
    ]
  },
 
  {
    path: 'dividend',
    data: {
      authorities: [],
      title: 'Chia cổ tức',
      header: 'Chia cổ tức'
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'prefix'
      },
      {
        path: 'list',
        component: DividendListComponent,
        data: {
          authorities: [],
          title: 'Danh sách',
        },
      },
      {
        path: 'create',
        component: EditDividendComponent,
        data: {
          authorities: [],
          title: 'Tạo mới',
        },
      },
      {
        path: 'edit/:id',
        component: EditDividendComponent,
        data: {
          authorities: [],
          title: 'Chỉnh sửa',
        },
      },
    ]
  },
  {
    path: 'upload-nav',
    component: NAVListComponent,
    data: {
      authorities: [],
      title: 'Upload NAV',
      header: 'Upload NAV'
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(productRoute)],
  exports: [RouterModule],
})
export class ProductRoutingModule { }
